import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import AllInboxIcon from '@material-ui/icons/AllInbox';

import {PortList, AreaList} from './List/List';
import {PortCreate, AreaCreate} from "./Create/Create";
import {PortEdit, AreaEdit} from "./Edit/Edit";

export const portsResource = {
	list: PortList,
	create: PortCreate,
	edit: PortEdit,
	icon: EmojiTransportationIcon,
}

export const areasResource = {
	list: AreaList,
	create: AreaCreate,
	edit: AreaEdit,
	icon: AllInboxIcon,
}
